import React from 'react'
import {PortableText} from '@portabletext/react'

const myPortableTextComponents = {
  types: {
    image: ({value}) => {
      if(value?.asset?.url) {
        return (
          <div style={{ paddingTop: '30px', paddingBottom: '50px'}}><img src={value.asset.url} /></div>
        )
      }
    },
    callToAction: ({value, isInline}) =>
      isInline ? (
        <a href={value.url}>{value.text}</a>
      ) : (
        <div className="callToAction">{value.text}</div>
      ),
  },
  marks: {
    beadc98f139b: ({children, value}) => {
      if(children[0].includes('@')) {
        return (
          <a style={{ textDecoration: 'underline' }} href={`mailto:${children[0]}`}>
            {children[0]}
          </a>
        )
      }
    },
    link: ({children, value}) => {
      if(value && !Array.isArray(value) && value.hasOwnProperty('href')) {
        return (
          <a style={{ textDecoration: 'underline' }} href={value.href} target="_blank" rel="noreferrer noopener">
            {children}
          </a>
        )
      }
    },
  },
}

const Portable2 = (props) => {

  const { value } = props;

  return (
    <PortableText value={value} components={myPortableTextComponents} />
  )

}

export default Portable2

